export default __webpack_public_path__ + "static/media/consult-bg-img.3af7cd60.png";